import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faBook, faCircleQuestion, faCartShopping, faVideo, faWallet, faGifts, faLocation } from '@fortawesome/free-solid-svg-icons';
import '../styles/sidebarProfile.css';

function SidebarProfile() {
  const menuItems = [
    { path: "/profile", name: "الملف الشخصي", icon: faHouse },
    { path: "/mycourses", name: "الكورسات الأجمالية", icon: faBook },
    { path: "/profile/courses", name: "  الكورسات اللي شاريها ", icon: faBook },
    { path: "/years", name: " نظام البوينتات ", icon: faGifts },
    { path: "/profile/quiz", name: "نتائج الامتحانات", icon: faCircleQuestion },
    { path: "/profile/homeworks", name: "نتائج الواجبات", icon: faCircleQuestion },
    { path: "/profile/videos", name: "فيديوهات الواجبات", icon: faVideo },
    { path: "/charge-wallet", name: "بيانات المحفظة", icon: faWallet },
    { path: "/profile/wallet", name: "الاشتراكات", icon: faCartShopping },
    { path: "/booksandcodes", name: "أماكن الأكواد والكتب", icon: faLocation },
    { path: "/centerschedules", name: " مواعيد المستر غي السناتر ", icon: faLocation },
  ];

  return (
    <aside className="sidebar-profile-main">
      <nav className="sidebar-nav">
        <ul>
          {menuItems.map((item, index) => (
            <li key={index}>
              <NavLink to={item.path} end={item.path === "/profile"}>
                <FontAwesomeIcon icon={item.icon} className="nav-icon" />
                <span className="nav-text">{item.name}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}

export default SidebarProfile;